import axios from "axios";
import { createClient } from "../util/axios-helpers";
import { endpoint } from "../util/http-helpers";

export interface Deal {
    id: string;
    partnerId: string;
    title: string;
    description: string;
    priceFrom: number | null;
    priceActual: number;
    photoUrl: string | null;
    category: string;
    productCode: string | null;
    enabled: boolean;
}

export interface DealsResponse {
    deals: Deal[];
    total: number;
}

export const getDeals = (partnerId?: string, category?: string) => {
    const client = createClient(axios);
    const params = new URLSearchParams();
    if (partnerId) params.append('partnerId', partnerId);
    if (category) params.append('category', category);

    const queryString = params.toString();
    const url = queryString
        ? endpoint(`api/v1/deals?${queryString}`)
        : endpoint('api/v1/deals');

    return client.get<Deal[]>(url);
};

export const getDealById = (dealId: string) => {
    const client = createClient(axios);
    return client.get<Deal>(endpoint(`api/v1/deals/${dealId}`));
};

export const getDealsByCategory = (category: string) => {
    const client = createClient(axios);
    return client.get<Deal[]>(endpoint(`api/v1/deals?category=${category}`));
};
